import axios from 'axios';
import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Swal from 'sweetalert2';
import { BASE_URL } from 'utils/constants';
import JoinTeamModalTeamCard from './JoinTeamModalTeamCard';

const JoinTeamModal = (props) => {
    // const globalState = useSelector((state) => state);
    // const name = useRef(null)
    // const note = useRef(null)
    // const [selectedId, SetselectedId] = useState('0')
    const [selectedId, setSelectedId] = useState("0");
    const JoinTeamFn = () => {
        // console.log("JoinTeamFn")
        if (selectedId) {
            Swal.showLoading();
            // // console.log("save")
            // setModalOpen(true);
            // // console.log(name)
            // // console.log(note?.current?.value)
            axios.post(`${BASE_URL}/capstone/teamformation/jointeam.php`, {
                team_id: selectedId,
            })
                .then(res => {
                    if (res?.data?.data) {
                        const res_data_data = res?.data?.data;
                        // console.log("res_data_data")
                        // console.log(res_data_data)
                        props.assignTeam(res_data_data)
                    }
                    Swal.fire('Saved!', '', 'success')

                }).catch(err => {
                    // console.log("err")
                    // console.log(err)
                    Swal.fire(err?.response?.data?.msg || "Sorry, this team is full, please choose another one", "", "error")
                    props.setAvailableTeams(props.availableTeams.filter((x) => (selectedId - 0) != (x.id - 0)))
                })
        }
    }

    return (
        <Modal
            isOpen={props.isOpen}
            toggle={props.toggle}
            centered={true}
            returnFocusAfterClose={false}
            unmountOnClose={false}
            backdrop={"static"}
        // size={"sm"}
        // fullscreen={"true"}
        >
            <ModalHeader toggle={props.toggle}>Select a Team</ModalHeader>
            <ModalBody>
                <div className='d-flex flex-wrap justify-content-center align-items-center ' >
                    {
                        props.availableTeams.map(team => {
                            return <JoinTeamModalTeamCard
                                key={team.id}
                                team={team}
                                setSelectedId={setSelectedId}
                                isSelected={selectedId === team.id}
                            />
                        })

                    }
                </div>
            </ModalBody>
            <ModalFooter>
                <button
                    className="btn btn-primary"
                    disabled={(selectedId - 0) ? false : true}
                    onClick={JoinTeamFn}>
                    Join Team
                </button>{' '}
                <button
                    className="btn btn-secondary"
                    onClick={props.toggle}>
                    Cancel
                </button>
            </ModalFooter>
        </Modal>
    )

}

export default JoinTeamModal